import { EnumToggle } from '@core/framework/sysenums.enum';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseState, SystemOptionEntity } from '@m4u-angular/base/entities/BaseEntities';
import { ColorInOutAnimation } from '@m4u-angular/ui/animations/colorinout.animation';

class State extends BaseState {
    Sections: any[] = [];
    InOut: EnumToggle = EnumToggle.Out;

    CurrentOption: SystemOptionEntity;
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-system-options-list',
    templateUrl: './system-options-list.component.html',
    styleUrls: ['./system-options-list.component.scss'],
    animations: [ColorInOutAnimation]
})
export class SystemOptionsListComponent extends BaseComponent<State> {

    @Input() set DataSource(value: SystemOptionEntity[]) {
        this.State.Sections = [];

        if (!value) { return; }

        this.CreateSections(value);
    }
    @Input() ModulesDataSource: any[];
    @Input() IsGeneral = false;

    @Output() DeleteOption: EventEmitter<SystemOptionEntity> = new EventEmitter<SystemOptionEntity>();

    constructor(A: ServiceBagService) {
        super(A, 'SystemOptionsListComponent', State);
    }

    GetElementID(option: SystemOptionEntity) {
        let id = option.OptionName;

        if (option.ModuleName) { id = `${id}_${option.ModuleName}`; }

        return id;
    }

    GetColorInOut(option: SystemOptionEntity) {
        if (!this.State.CurrentOption) { return EnumToggle.Out; }

        if (this.State.CurrentOption.OptionName === option.OptionName && this.State.CurrentOption.ModuleName === option.ModuleName) {
            return this.State.InOut;
        }

        return EnumToggle.Out;
    }

    ShowOption(option: SystemOptionEntity) {
        this.State.CurrentOption = option;

        setTimeout(() => {
            const element = document.getElementById(this.GetElementID(option));

            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                const inputs = element.getElementsByTagName('input');

                if (inputs.length > 0 && inputs[0].attributes['type'] !== 'hidden') {
                    inputs[0].focus();
                }

                this.State.InOut = EnumToggle.In;

                setTimeout(() => { this.State.InOut = EnumToggle.Out; });
            }
        });

    }

    OnDeleteOption(option: SystemOptionEntity) {
        this.DeleteOption.emit(option);
    }

    private CreateSections(options: SystemOptionEntity[]) {
        let section;

        for (let i = 0; i < options.length; i++) {
            section = this.State.Sections.find(x => x.name === options[i].SectionInfo);

            if (section == null) {
                section = {
                    name: options[i].SectionInfo,
                    index: options[i].SectionIndex,
                    label: this.IsGeneral ? this.RC('lbl' + options[i].SectionInfo) : options[i].SectionInfo,
                    options: []
                };

                this.State.Sections.push(section);
            }

            section.options.push(options[i]);
        }

        for (let i = 0; i < this.State.Sections.length; i++) {
            this.State.Sections[i].options = this.State.Sections[i].options.sort((a, b) => {
                if (a.OptionName > b.OptionName) { return 1; }
                if (a.OptionName < b.OptionName) { return -1; }
                return 0;
            });
        }

        this.State.Sections = this.State.Sections.sort((a, b) => a.index - b.index);
    }

}
